import { HttpResponse } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { FileDownloadService } from '@services/file-download.service';
import { UploadFileService } from '@services/upload-file.service';
import { FilenameParser } from '@utils/FilenameParser';
import { take } from 'rxjs/operators';
import { VisualizarErrosImportacaoService } from 'src/app/services/visualizar-erros-importacao.service';
import { GoogleComponent } from '@pages/utils/google.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { TagManagerDirective } from '../../directives/tag-manager.directive';
import { FooterComponent } from '../../components/footer/footer.component';
import { CamelCasePipe } from '../../pipes/camel-case.pipe';

@Component({
    selector: 'app-visualizar-erros-importacao',
    templateUrl: './visualizar-erros-importacao.component.html',
    styleUrls: ['./visualizar-erros-importacao.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, BreadcrumbComponent, TagManagerDirective, FooterComponent, CamelCasePipe]
})
export class VisualizarErrosImportacaoComponent extends GoogleComponent implements OnInit {

  private readonly idImportacao: any;
  public errosLayout: any = null;
  qtdeErrosLayout: number;

  private readonly sectionApp = 'visualizar-erros-de-importacao';
  private readonly screenName = 'visualizar-erros-de-importacao:home';
  private readonly screenType = 'pagina';

  constructor(
    private readonly service: VisualizarErrosImportacaoService,
    private readonly uploadFileService: UploadFileService,
    private readonly router: Router,
  ) {
    super();
    this.idImportacao = localStorage.idImportacao;
  }

  ngOnInit(): void {
    this.consultarErrosLayout();
    this.pushScreenView(this.sectionApp, this.screenName, this.screenType);
  }

  addTagManagerInteraction(elementType: string, elementContent: string) {
    return this.buildTagInteraction(elementType, elementContent, this.sectionApp, this.screenName, this.screenType);
  }

  consultarErrosLayout() {
    this.service.getErrosLayout(this.idImportacao).pipe(take(1)).subscribe({
      next: (response: any) => {
        this.errosLayout = response.response.listErrors;
        this.qtdeErrosLayout = response.response.totalErrors;
      },
      error: (erro: any) => {
        console.error('Problema ao consultar erros de layout', erro);
        this.errosLayout = false;
      }
    });
  }

  baixarRelatorioLayout() {
    this.service.baixarRelatorioLayout(this.idImportacao).subscribe(
      ({ body, headers }: HttpResponse<any>) => {
        const filename = FilenameParser.fromContentDispositionHeader(headers.get('content-disposition'), 'Arquivo.csv');
        FileDownloadService.download([body], filename);
      });
  }

  cancelarImportacao() {
    this.uploadFileService.finalizaImportacao(this.idImportacao, 'cancelar').pipe(take(1)).subscribe(() => {
      localStorage.removeItem(localStorage.getItem('idEmpresaLogada') + '.sawImportationError');
      this.router.navigate(['/importador-dados']);
    });
  }

}
